export enum STORES_TYPES {
  GET_STORELIST_REQUEST = '@openClaim/GET_STORELIST_REQUEST',
  SET_DATA_STORELIST = '@openClaim/SET_DATA_STORELIST',
}

export interface Store {
  code: string;
  name: string;
}

export interface StoreState {
  storeList: Store[];
}
